var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import LoginService from "../../src/api/LoginService";
import { Loading } from 'element-ui';
var ManagementLandingCustom = (function (_super) {
    __extends(ManagementLandingCustom, _super);
    function ManagementLandingCustom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 500;
        _this.landingCustom = '';
        return _this;
    }
    ManagementLandingCustom.prototype.data = function () {
        return {
            sortValue: 1
        };
    };
    ManagementLandingCustom.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 80;
            }
        }, 300);
        this.service = LoginService.getInstance();
        this.getManagementLandingCustom();
    };
    ManagementLandingCustom.prototype.getManagementLandingCustom = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var loadingInstance = Loading.service({ fullscreen: true });
        var id = this.$route.query.id;
        var param = {
            'id': id,
        };
        this.service.getManagementLandingCustom(param).then(function (res) {
            loadingInstance.close();
            var DATA = res.data ? res.data : {};
            _this.landingCustom = DATA.data;
            console.log(1111, _this.landingCustom);
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    ManagementLandingCustom = __decorate([
        Component({
            components: {}
        })
    ], ManagementLandingCustom);
    return ManagementLandingCustom;
}(Vue));
export default ManagementLandingCustom;
